<template>
  <v-card class="d-flex flex-column" height="100vh">
    <v-sheet class="flex-grow-1 overflow-auto">
      <v-toolbar color="primary" density="compact" class="px-4">
        <v-icon icon="mdi-clipboard-list" class="mr-2"></v-icon>
        <v-toolbar-title class="text-subtitle-1 font-weight-medium">
          {{ record?.id }}#{{ task.id }}
          <span v-if="record?.title" class="font-weight-regular opacity-90">
        - {{ record.title }}
      </span>
        </v-toolbar-title>
      </v-toolbar>
      <v-sheet v-if="!isStartable(record, task.id)"
               class="flex-grow-1 d-flex align-center justify-center">
        <span class="ml-2 color_error pr-2"> Vorherige Aufgabe ist nicht beendet!</span>
      </v-sheet>
      <v-tabs
          v-model="currentEditTab"
          :items="editTabs"
          align-tabs="center"
          color="primary"
          height="60"
          slider-color="primary"
      >
        <template v-slot:tab="{ item }">
          <v-tab
              :prepend-icon="item.icon"
              :text="item.text"
              :value="item.value"
              class="text-none"
          ></v-tab>
        </template>

        <template v-slot:item="{ item }">
          <v-tabs-window-item :value="item.value" class="pa-4">
            <TaskInformationDialog v-if="item.value === 'tab-1'" v-model="task"
                                   :readonly="useGlobalSetting().globalReadonly"/>
            <FeedbackForm v-if="item.value === 'tab-2'" v-model="task"/>
            <TimeLine v-if="item.value === 'tab-3'" v-model="record" v-model:aufgabe="task"/>
          </v-tabs-window-item>
        </template>
      </v-tabs>
    </v-sheet>

    <v-divider></v-divider>

    <v-card-actions class="bg-surface-light">

      <v-btn variant="plain" @click="cancel(); currentEditTab = 'tab-1'; useGlobalSetting().hasChanged = false;">
        <v-icon color="red" icon="mdi-cancel" start></v-icon>
        Abbrechen
      </v-btn>

      <v-spacer></v-spacer>
      <v-btn :disabled="!useGlobalSetting().hasChanged || !canSave" text="Save" @click="submit">
        <v-icon color="green" icon="mdi-checkbox-marked-circle" start></v-icon>
        Speichern
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>
import {Feedback, isStartable, Order, Task} from "@/types/Order";
import FeedbackForm from "@/components/forms/FeedbackForm.vue";
import TimeLine from "@/components/misc/TimeLine.vue";
import {computed, shallowRef} from "vue";
import TaskInformationDialog from "@/components/dialogs/TaskInformationDialog.vue";
import {useGlobalSetting} from "@/lib/utils";
import {addFeedback} from "@/api";
import {updateTaskState} from "@/api/tasks";

const record = defineModel<Order>();

//console.log("record", record.value);

const props = defineProps({
  id: {
    type: Number,
    required: true
  },
  onClose: {
    type: Function,
    required: true
  },
  currentTab: {
    type: String,
    required: false,
    default: 'tab-1'
  }
});

const task = computed<Task>(() => record.value?.tasks.find(aufg => aufg.id == props.id));

const canSave = computed(() => {
  const newFeedbacks = task.value?.feedbacks?.filter(fb => fb._isNew) ?? []
  return newFeedbacks.every(fb => fb.duration && fb.duration !== '')
})


const currentEditTab = shallowRef<string>(props.currentTab);

interface EditTab {
  icon: string;
  text: string;
  value: string;
}

const editTabs: EditTab[] = [
  {
    icon: 'mdi mdi-information-slab-box',
    text: 'Information',
    value: 'tab-1'
  },
  {
    icon: 'mdi mdi-reply',
    text: 'Rückmeldung',
    value: 'tab-2'
  },
  {
    icon: 'mdi mdi-book-clock-outline',
    text: 'Zeitplan',
    value: 'tab-3'
  },
]

function cancel() {
  useGlobalSetting().hasChanged = false;
  props.onClose?.();
}

async function submit() {
  const newFeedbacks = task.value.feedbacks.filter(fb => fb._isNew).map(({_isNew, id, task_id, ...rest}) => rest) as Feedback[]

  await updateTaskState(task.value);

  await addFeedback(task.value.uuid, newFeedbacks)
  useGlobalSetting().hasChanged = false;
  props.onClose?.();
}

</script>